import { getStore, setStore } from '@/utils/store'
import { getCurrentUserInfo } from '@/api/corporation/user'
import { getCorpCostStatistics } from '@/api/corporation/app'

/**
 * api端使用
 */
export default {
  namespaced: true,
  state: {
    idCode: getStore({ name: 'corpIdCode' }) || '',
    // 企业端菜单隐藏显示
    corpMenu: getStore({ name: 'corpMenu' }) || {
      api: false,
      h5: false,
      wx: false
    },
    // 企业用户信息
    userInfo: getStore({ name: 'corpUserInfo' }) || {},
    // 企业消费统计信息（剩余点数、总消费点数、充值金额）
    corpCostStatistics: getStore({ name: 'corpCostStatistics' }) || { balance: 0, consume: 0, recharge: 0 }
  },
  mutations: {
    SET_ID_CODE: (state, idCode) => {
      state.idCode = idCode
      setStore({
        name: 'corpIdCode',
        content: idCode
      })
    },
    SET_CORP_MENU: (state, menu) => {
      state.corpMenu = menu
      setStore({
        name: 'corpMenu',
        content: menu
      })
    },
    SET_CORP_USERINFO: (state, userInfo) => {
      // 添加时间戳
      if (userInfo) {
        userInfo.datetime = new Date().getTime()
      }
      state.userInfo = userInfo
      setStore({
        name: 'corpUserInfo',
        content: userInfo
      })
    },
    SET_CORP_COST_STATISTICS: (state, { balance, consume, recharge }) => {
      state.corpCostStatistics = {
        // 剩余点数
        balance,
        // 总消费点数
        consume,
        // 充值金额
        recharge,
        // 时间戳
        datetime: new Date().getTime()
      }
      setStore({
        name: 'corpCostStatistics',
        content: state.corpCostStatistics
      })
    }
  },
  actions: {
    /**
     * 获取企业费用统计数据
     * @param {*} param0
     * @param {*} enforce 是否强制获取
     * @returns
     */
    getCorpCostStatistics({ commit, state, dispatch }, enforce = false) {
      return new Promise((resolve, reject) => {
        // 剩余点数
        let balance = state.corpCostStatistics.balance || 0
        // 总消费点数
        let consume = state.corpCostStatistics.consume || 0
        // 充值金额
        let recharge = state.corpCostStatistics.recharge || 0
        // 时间戳
        let datetime = state.corpCostStatistics.datetime
        // 返回值
        let result = { balance, consume, recharge }
        if (datetime && new Date().getTime() - datetime < 60 * 1000 && !enforce) {
          // 1分钟内的直接从缓存中获取
          resolve(result)
        } else {
          // 第一次获取，或者离上一次获取超过1分钟
          getCorpCostStatistics()
            .then((resp) => {
              let data = resp.data
              if (data.code === 0) {
                result.balance = data.data[0]
                result.consume = data.data[1]
                result.recharge = data.data[2]
                commit('SET_CORP_COST_STATISTICS', result)
              }
              resolve(result)
            })
            .catch(() => resolve(result))
        }
      })
    },
    /**
     * 更新当前登录用户信息，包括企业认证状态信息
     */
    refreshCurrentUserInfo({ commit, state, dispatch }) {
      // 旧的认证状态
      const oldCertificationStatus = state.userInfo.corpCertificationStatus
      return new Promise((resolve, reject) => {
        getCurrentUserInfo()
          .then((resp) => {
            let data = resp.data
            if (data && data.code === 0) {
              commit('SET_CORP_USERINFO', data.data)
              // 新的认证状态
              const newCertificationStatus = data.data.corpCertificationStatus
              // 认证通过，重新构建路由
              if (oldCertificationStatus !== 1 && newCertificationStatus === 1) {
                dispatch('refreshRoutes', null, { root: true })
              }
              resolve()
            } else {
              reject(data.msg)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/corporation.js